import { t } from '@avalara/bat-apps-shared/i18n';
import { SBox, SCol, SContainer, SRow } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { hideHeaderSignIn } from '../../lib/aui-header';
import { getSystemErrorMessaging } from '../../lib/side-effects/error';
import { setEsbBackground } from '../../lib/side-effects/esb';
import { selectState } from '../../selectors';
import { getEsbPartnerName } from '../../selectors/esb';
import ExternalLink from '../external-link';
import { getEsbConnectorUrl } from '../helpers/redirect';

const SignIn = () => {
  const dispatch = useDispatch();
  const {
    esb: { connectorReturnUrl },
  } = useSelector(selectState);
  const esbConnectorUrl = getEsbConnectorUrl({ connectorReturnUrl });
  const disabled = esbConnectorUrl === '';
  const partnerName = useSelector(getEsbPartnerName);

  useEffect(() => {
    if (disabled) dispatch(getSystemErrorMessaging({ errorCode: 'esbReturnUrlMissing', partnerName }));
  }, [disabled, partnerName]);

  useEffect(hideHeaderSignIn, []);

  useEffect(setEsbBackground('esb-create'));

  return (
    <SBox className='pad-all-none'>
      {/* biome-ignore lint/a11y/useSemanticElements: skylab element is used for styling */}
      <SContainer role='main' id='esb-create' className='pad-top-xl'>
        <SRow>
          <SCol span='5'>
            <SBox className='pad-all-lg pad-top-sm'>
              <h1 className='pad-bottom-lg'>{t('client.headings.your-avalara-account-has-been-created')}</h1>
              <p className='margin-bottom-lg'>
                {t('client.general.to-confirm-your-identity-sign-in-with-your-email-and-passwor')}
              </p>
              {!disabled && (
                <ExternalLink
                  href={esbConnectorUrl}
                  className='primary button margin-top-xl'
                  data-ref='esb.sign-in-page.go-button'
                  color='white'
                >
                  {t('client.general.go')}
                </ExternalLink>
              )}
            </SBox>
          </SCol>
        </SRow>
      </SContainer>
    </SBox>
  );
};

export default SignIn;
